import { useState, useEffect } from "react";

interface FlipbookViewerProps {
  title: string;
  thumbUrl?: string;
  downloadUrl?: string;
}

export default function FlipbookViewer({
  title,
  thumbUrl,
  downloadUrl,
}: FlipbookViewerProps) {
  const [pdfError, setPdfError] = useState(false);

  useEffect(() => {
    setPdfError(false);
  }, [downloadUrl]);

  if (downloadUrl && !pdfError) {
    return (
      <div className="mb-14">
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
          <div className="bg-gray-50 px-4 py-3 border-b border-gray-200 flex items-center justify-between">
            <h3 className="text-sm font-semibold text-gray-800">{title}</h3>
            <a
              href={downloadUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs font-medium text-emerald-700 hover:text-emerald-800 underline underline-offset-2 cursor-pointer"
            >
              Open in new tab
            </a>
          </div>
          <embed
            src={downloadUrl}
            type="application/pdf"
            className="w-full border-0"
            style={{ height: 650, minHeight: 400 }}
            onError={() => setPdfError(true)}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="mb-14">
      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
        <div className="bg-gray-50 px-4 py-3 border-b border-gray-200">
          <h3 className="text-sm font-semibold text-gray-800">{title}</h3>
        </div>
        <div className="flex flex-col items-center justify-center py-12 md:py-16 bg-gray-50">
          {thumbUrl ? (
            <img
              src={thumbUrl}
              alt={title}
              className="max-h-[400px] max-w-full object-contain rounded shadow-md"
            />
          ) : (
            <div className="flex items-center justify-center w-20 h-20 rounded-full bg-gray-200 mb-4">
              <i className="ri-file-pdf-line text-3xl text-gray-400"></i>
            </div>
          )}
          <p className="text-sm text-gray-500 mt-4">
            {pdfError ? "PDF could not be loaded." : "Brochure preview"}
          </p>
          <a
            href="/contact"
            className="mt-4 inline-block bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-6 py-2.5 rounded-md text-sm transition-colors whitespace-nowrap cursor-pointer"
          >
            Contact us for full brochure
          </a>
        </div>
      </div>
    </div>
  );
}